import type { PlayerVipLevel } from '~/types/player-profile';

// Normalização do nível VIP que o core manda em `/players/me`.
//
// Vive aqui, e não no mapper do adapter, porque DOIS lugares recebem esse objeto
// de fora e nenhum dos dois pode confiar no que chega: a resposta do core (wire)
// e o memo desta aba (sessionStorage, que o próprio jogador consegue editar pelo
// devtools). Como o `tag` escolhe a arte do card, um valor forjado ali viraria
// badge de VIP 6 — então quem lê revalida, sempre, pelo mesmo caminho.
//
// `vip` só existe com `tag`: um objeto sem ela não descreve nível nenhum e vira
// jogador comum, mesmo caminho de um `null` explícito.
export function normalizePlayerVip(value: unknown): PlayerVipLevel | null {
  if (!value || typeof value !== 'object') return null;

  const raw = value as Record<string, unknown>;

  if (typeof raw.tag !== 'string' || !raw.tag) return null;

  return {
    tag: raw.tag,
    // `order` é o NÍVEL (ver PlayerVipLevel), então não tem default numérico:
    // 0 é um nível de verdade (VIP 0, com arte própria) e cair nele por payload
    // quebrado promoveria um jogador comum a VIP. Ausente ⇒ `null` ⇒ arte padrão.
    order: typeof raw.order === 'number' ? raw.order : null,
    color: typeof raw.color === 'string' ? raw.color : null,
  };
}
